import { render, staticRenderFns } from "./AIDrawer.vue?vue&type=template&id=768ea268&scoped=true"
import script from "./AIDrawer.vue?vue&type=script&lang=js"
export * from "./AIDrawer.vue?vue&type=script&lang=js"
import style0 from "./AIDrawer.vue?vue&type=style&index=0&id=768ea268&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "768ea268",
  null
  
)

export default component.exports